import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"padding-bottom":"100px"} }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "py-3 heading" }
const _hoisted_4 = { class: "text-primary-green" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "my-3 title-4" }
const _hoisted_7 = {
  id: "email",
  class: "mb-3"
}
const _hoisted_8 = {
  id: "password1",
  class: "mb-3"
}
const _hoisted_9 = {
  id: "password2",
  class: "mb-3"
}
const _hoisted_10 = { class: "my-4 d-flex justify-content-end" }

import { reactive, computed, ref, onMounted, onBeforeUnmount } from "vue"

// common components
import Banner from "@/components/LoginRegister/common/Banner/v1/Banner.vue"
import ContainerBox from "@/components/LoginRegister/common/ContainerBox/v1/ContainerBox.vue"
import TextInput from "@/components/LoginRegister/common/inputs/Text/v1/Text.vue"
import FieldError from "@/components/LoginRegister/common/FieldError/v1/FieldError.vue"
import Button from "@/components/LoginRegister/common/Button/v1/Button.vue"
import Overlay from "@/components/LoginRegister/common/Overlay/v1/Overlay.vue"

// svg
import EyeSvg from "@/components/LoginRegister/svg/EyeSvg.vue"

// composables
import useLoading, { isLoadingAny } from "@/composables/useLoading"

// libs
import { onKeyStroke } from "@vueuse/core"

// logic
import newPassword from "@/logic/contact/newPassword"
import decodeHash from "@/logic/contact/decodeHash"
import checkIsHashExpired from "@/logic/contact/checkIsHashExpired"

// utils
import {getQueryParams} from "@/utils"

// state
import email from "@/state/email"
import current_form from "@/state/current_form"
import showResetPopUp from "@/state/showResetPopUp"
import loadingSet from "@/state/loadingSet"

// config
import UserInfoFormEnum from "@/config/UserInfoFormEnum"

// translations
import { useI18n } from "vue-i18n"

export default /*@__PURE__*/_defineComponent({
  __name: 'NewPasswordForm',
  setup(__props) {

const {t} = useI18n()

// state
const state = reactive({
	isSeePassword: false,
	showErrors: false,
})

const isSuccess = ref(false)
const hash = ref("")
const password1 = ref("")
const password2 = ref("")

// computed
const invalidFields = computed(() => {
	const invalidFields = new Set<string>()

	if (!password1.value) invalidFields.add("password1")
	if (!password2.value) invalidFields.add("password2")
	if (password1.value.length < 8) invalidFields.add("password1")
	if (password2.value.length < 8) invalidFields.add("password2")

	if (password1.value !== password2.value) invalidFields.add("password2")
	return invalidFields
})

// handlers
const handleButtonClick = async () => {
	if (invalidFields.value.size > 0) {
		state.showErrors = true
		return
	}
	state.showErrors = false

	const { startLoadingThis, stopLoadingThis } = useLoading("new-password-call")
	startLoadingThis()
	await newPassword(hash.value, password1.value)
	stopLoadingThis()
	current_form.value = UserInfoFormEnum.Login
	isSuccess.value = true
}
const handlePassword1Change = (newValue: string) => {
	password1.value = newValue
}
const handlePassword2Change = (newValue: string) => {
	password2.value = newValue
}
const handleToggleSeePassword = () => {
	state.isSeePassword = !state.isSeePassword
}

onMounted(async () => {
	const { startLoadingThis, stopLoadingThis } = useLoading(
		"new-password-mounted"
	)
	startLoadingThis()

	document.querySelector("body")!.style.visibility = "visible"
	const query = getQueryParams()
	if (!query.hash) throw new Error("hash must be a query param")
	const decodedHash = decodeHash(query.hash)
	if (!decodedHash) throw new Error("no decoded hash in newPassword")
	if (!decodedHash.email) throw new Error("email must be in decoded hash")
	if (!decodedHash.exp) throw new Error("exp must be in decoded hash")

	hash.value = query.hash
	email.value = decodedHash.email

	const expirationMiliSeconds: number = decodedHash.exp * 1000
	const isDecodedHashExpired: boolean = checkIsHashExpired(
		expirationMiliSeconds
	)
	if (isDecodedHashExpired) {
		current_form.value = UserInfoFormEnum.Reset
		// If the hash is expired, set the state to true to display the popup to reset again
		showResetPopUp.value = true
	}

	// onKeyStroke
	const stop = onKeyStroke("Enter", () => {
		handleButtonClick()
	})
	onBeforeUnmount(() => stop())

	stopLoadingThis()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.new_password_forgot_password")), 1)
      ]),
      _createVNode(ContainerBox, { class: "p-3 p-lg-4 position-relative" }, {
        default: _withCtx(() => [
          (isSuccess.value)
            ? (_openBlock(), _createBlock(Banner, {
                key: 0,
                background: 'var(--green-100)'
              }, {
                text: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("loginRegister.new_password_succes")), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("form", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.new_password_create_new_password")), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(TextInput, {
                    disabled: true,
                    value: _unref(email),
                    placeholder: _unref(t)('loginRegister.contacts_email') + '*',
                    "container-box-border": 
								state.showErrors && invalidFields.value.has('email')
									? '1px solid var(--primary-orange)'
									: undefined
							
                  }, null, 8, ["value", "placeholder", "container-box-border"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(TextInput, {
                    value: password1.value,
                    placeholder: _unref(t)('loginRegister.new_password1') + '*',
                    "input-type": state.isSeePassword ? 'text' : 'password',
                    "container-box-border": 
								state.showErrors && invalidFields.value.has('password1')
									? '1px solid var(--primary-orange)'
									: undefined
							,
                    onInput: _cache[1] || (_cache[1] = (newVal) => handlePassword1Change(newVal))
                  }, {
                    after: _withCtx(() => [
                      (password1.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            role: "button",
                            onClick: _cache[0] || (_cache[0] = () => handleToggleSeePassword()),
                            class: "mx-3 my-2"
                          }, [
                            _createVNode(EyeSvg, {
                              opacity: state.isSeePassword ? 1 : 0.5,
                              color: 'var(--primary-blue)'
                            }, null, 8, ["opacity"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["value", "placeholder", "input-type", "container-box-border"]),
                  (state.showErrors && invalidFields.value.has('password1'))
                    ? (_openBlock(), _createBlock(FieldError, { key: 0 }, {
                        default: _withCtx(() => [
                          (!password1.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(t)("loginRegister.user_info_mandatory_field")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(TextInput, {
                    value: password2.value,
                    placeholder: _unref(t)('loginRegister.new_password2') + '*',
                    "input-type": state.isSeePassword ? 'text' : 'password',
                    "container-box-border": 
								state.showErrors && invalidFields.value.has('password2')
									? '1px solid var(--primary-orange)'
									: undefined
							,
                    onInput: _cache[3] || (_cache[3] = (newVal) => handlePassword2Change(newVal))
                  }, {
                    after: _withCtx(() => [
                      (password2.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            role: "button",
                            onClick: _cache[2] || (_cache[2] = () => handleToggleSeePassword()),
                            class: "mx-3 my-2"
                          }, [
                            _createVNode(EyeSvg, {
                              opacity: state.isSeePassword ? 1 : 0.5,
                              color: 'var(--primary-blue)'
                            }, null, 8, ["opacity"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["value", "placeholder", "input-type", "container-box-border"]),
                  (state.showErrors && invalidFields.value.has('password2'))
                    ? (_openBlock(), _createBlock(FieldError, { key: 0 }, {
                        default: _withCtx(() => [
                          (!password2.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(t)("loginRegister.user_info_mandatory_field")), 1)
                              ], 64))
                            : (password1.value !== password2.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_unref(t)("loginRegister.contacts_passwords_dont_match")), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createVNode(Button, {
                      disabled: state.showErrors && invalidFields.value.size > 0,
                      onButtonClick: handleButtonClick
                    }, {
                      text: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.validate")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ])
              ])),
          (_unref(loadingSet).size)
            ? (_openBlock(), _createBlock(Overlay, {
                key: 2,
                additionalClasses: ['loader']
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})